import { Injectable } from "@angular/core";
import { TicketModel } from "../services/sso/models/ticket.model";
import { GenericRepository } from "./generic-repository";

@Injectable({
  providedIn: 'root'
})
export class SsoRepository extends GenericRepository<TicketModel> {
  public constructor() {
    super();
  }

  public fetch(): void {
    throw new Error("Method not implemented.");
  }
  public save(item: TicketModel): void {
    throw new Error("Method not implemented.");
  }
  public update(item: TicketModel): void {
    throw new Error("Method not implemented.");
  }
  public delete(id: number): void {
    throw new Error("Method not implemented.");
  }

  public getTicket(): TicketModel {
    let ticket: TicketModel = <TicketModel>JSON.parse(sessionStorage.getItem('ticketSSO'));
    if (!ticket) {
      ticket = <TicketModel>JSON.parse(localStorage.getItem('ticketSSO'));
      if (ticket) {
        sessionStorage.setItem('ticketSSO', JSON.stringify(ticket));
      }
    }
    return ticket;
  }
}

